import script from "./ConsoleWorkspaces.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleWorkspaces.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleWorkspaces.vue?vue&type=style&index=0&id=9c08fbe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c08fbe6"]])

export default __exports__